import * as React from 'react';
import { Dialog } from '../../Common/Dialog';
import { Button, ButtonStyle } from '../../Forms/Button';
import './style.css';

export interface CancelPremiumDialogProps {
  onAccept: () => void;
  onClose: () => void;
}

export interface CancelPremiumDialogState {
  /* empty */
}

export class CancelPremiumDialog extends React.Component<
  CancelPremiumDialogProps,
  CancelPremiumDialogState
> {
  render() {
    const { onAccept, onClose } = this.props;

    return (
      <Dialog onClose={onClose} title="Cancel premier membership">
        <div className="cancel-premium-confirm-dialog">
          <p>Are you sure you want to cancel your premier membership?</p>

          <div className="cancel-premium-confirm-dialog__buttons">
            <Button
              type="button"
              className="cancel-premium-confirm-dialog__cancel-button"
              onClick={onClose}
            >
              No, I'd like to stay
            </Button>

            <Button
              type="button"
              buttonStyle={ButtonStyle.Danger}
              className="cancel-premium-confirm-dialog__accept-button"
              onClick={onAccept}
            >
              Yes, I want to cancel
            </Button>
          </div>
        </div>
      </Dialog>
    );
  }
}

export default CancelPremiumDialog;



// WEBPACK FOOTER //
// ./src/app/components/UserProfile/CancelPremiumDialog/index.tsx